import { Locale } from './language'

/**
 * Gets Shopify cart ID local storage key.
 */
export const getShopifyCartIdStorageKey = (locale: Locale) => {
  return `cart_id_${locale}`
}

/**
 * Gets institution ID local storage key.
 */
export const getInstitutionIdStorageKey = (locale: Locale) => {
  return `institution_id_${locale}`
}
